import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedOption, removeResumenData, updateDominioPrincipal, addResumenData, setIdResumen, setTransferenciaExitosa } from '../../globalslice';
import getTransferInfo from '../../services/TransferInfo';
import '../../styles/Transferencia.scss';
import bsqicon from '../../images/bsq-icon.svg';
import bsqicon2 from '../../images/bsq-icon-orange.svg';
import loadingIcon from '../../images/loading.png';
import { useTranslation } from 'react-i18next';
import getDomainPrices from '../../services/PriceDomain';
import calculatePriceDetails from '../../services/calculatePriceDetails';
import isProductWithHosting from '../../helpers/isProductWithHosting';
import validateAlreadyExistInCart from '../../helpers/validateAlreadyExistInCart';
import validateAndCleanDomain from '../../helpers/validateAndCleanDomain';

const Transferencia = ({currentDomain, productActual = {}}) => { // envía parametros solo en la landing de transfersearch.jsx
  
  const [icon, setIcon] = useState(bsqicon);
  const [dominioTransferencia, setDominioTransferencia] = useState(currentDomain || ''); // Usa currentDomain si viene de TransferSearch
  const [inputError, setInputError] = useState('');
  const [loading, setLoading] = useState(false);
  const [msgresult, setMessageResult] = useState('green');
  const [message, setMessage] = useState(null);
  let resTransferencia = null; 
  const selectedOption = useSelector((state) => state.global.selectedOption);
  const resumenData = useSelector((state) => state.global.ResumenData);
  const idResumen = useSelector(state => state.global.idResumen);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currency = useSelector((state) => state.global.currency);
  const hasRun = useRef(false);

  const handleOptionChange = (option) => {
    dispatch(setSelectedOption(option));
    if(option === 'opc-trans'){
      resumenData.forEach(element => {
          if(element.actual && element.type != 'domain'){
            dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:null, domainType: null }));
          } else if(element.actual && element.type == 'domain'){
            dispatch(removeResumenData(element.id));
          }
      });
      setDominioTransferencia('');
      setMessage(null);
      setMessageResult('green');
    }
  };

  const handleTransferir = async (auto) => {
    const abortController = new AbortController();
    let privacy, privacyCost = null;
    if (dominioTransferencia.trim() === '') {
      setInputError(true);
      return;
    }
    setInputError(false);
    setLoading(true);
    try {

      //Validate if the domain already exists in the cart
      let domainExists = validateAlreadyExistInCart(resumenData, dominioTransferencia);

      if (domainExists) {
        // If the domain already exists in the cart, stop the flow and show the message
        setMessageResult('red');
        setMessage(t('cart.config.domain.already_exist'));
        setLoading(false);
        return; // Leave the flow
      }

      //validate the domain and set the state of domain
      let domain_clean = await handleValidateDomain(dominioTransferencia);

      // TLD not supported by neubox
      if(domain_clean && domain_clean === "tld_transfer") {
        setMessage(t('cart.config.domain.not_valid_tld'));
        setMessageResult('red');
        setLoading(false);
        return;
      }
      //if the domain is not valid, show an error message and return
      else if (!domain_clean) {
        setMessage(t('cart.config.domain.not_valid'));
        setMessageResult('red');
        setLoading(false);
        return;
      }

      resTransferencia = await getTransferInfo({ dominioTransferencia: domain_clean });

      if (resTransferencia.success === 'success') {
        if (resTransferencia.classerror === 'green') {
          // elimina item de transferencia, si existe
          await resumenData.forEach(element => {
            if(element.actual && element.type === 'domain' && element.product.name === 'Transferencia de Dominio'){
              dispatch(removeResumenData(element.id));
            }
          });
          let domainPrice;
          const conHosting = isProductWithHosting(productActual);
          const domainPriceSin = await getDomainPrices({ domain: domain_clean, currency, type: "solo", typeDomainRegister: "transfer" }, abortController.signal);

          // si el dominio cuenta con hosting gratis, se obtienen los precios desde backend
          if (conHosting) {
            const productId = productActual?.product?.id ?? 0;
            domainPrice = await getDomainPrices({ domain: domain_clean, currency, type: "con", typeDomainRegister: "transfer", productId },abortController.signal);
          } else {
            // si el producto no cuenta con hosting gratis, se asigna el resultado de precio sin hosting
            domainPrice = domainPriceSin;
          }

          const { newPrice } = calculatePriceDetails(domainPrice, domainPriceSin, 1);
          
          if (domainPrice?.protection[0]?.protectionid) {
            privacyCost = domainPrice?.protection[0]?.protectionprice ?? null;
            privacy = domainPrice?.protection[0]?.protectionid ?? null;
          }

          dispatch(addResumenData({
            product: {
              name: 'Transferencia de Dominio',
              smallname: 'Transferencia de Dominio',
              description: ``,
              domain_section: [
                {
                  'dominio_principal': dominioTransferencia,
                  domain_type: 'transfer'
                }
              ],
              ...(privacy && { privacy_protection: false })
            },
            price:{
              cost: newPrice.cost,
              second_price: newPrice.second_price, // precio real
              cross_price: conHosting && parseFloat(newPrice.second_price) === 0,
              ...(privacyCost && { privacy_cost: privacyCost }),
              ...(privacyCost && { privacy_period: '1 año (s)' }),
              ...(privacyCost && { default_privacy_cost: privacyCost }),
            },
            periodo: '1 año (s)',
            id: idResumen,
            actual : true,
            type: 'domain',
            selectPeriods: []
          }));

          dispatch(setIdResumen());

          resumenData.forEach(element => {
            if(element.actual && element.actual !== 'dominio'){
              dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal: dominioTransferencia, domainType: 'transfer' }));
            }
          });

          if(auto == "auto"){
            //transferencia posible, enviar a checkout
            dispatch(setTransferenciaExitosa(true)); 
          }
        }

        setMessage(resTransferencia.message);
        setMessageResult(resTransferencia.classerror);
      } else {
        setMessage(resTransferencia.message); 
        setMessageResult('red');
      }
    } catch (error) { 
      setMessage('Error al buscar la información del dominio.');
      setMessageResult('red');
    } finally {
      setLoading(false);
    }
  };

  /**
 * This function validates the domain and returns the cleaned domain or null if it is not valid furhermore sets the state of domain
 * @param {*} domain 
 * @returns result or null
 */
  const handleValidateDomain = async (domain) => {
    const result = validateAndCleanDomain(domain, true, true, "transfer");
    if (!result.isValid) {
      return result.error; // Return error if not valid
    }

    setDominioTransferencia(result.cleanDomain); // Set the state of domain

    return result.cleanDomain; // Return the cleaned domain
  };

  useEffect(() => {
    if (!hasRun.current && currentDomain) {
      handleTransferir("auto");
      hasRun.current = true;
    }
  }, [currentDomain]);
  return (
    <div className={`bsq-dominio ${selectedOption === 'opc-trans' ? 'active' : ''}`}>
      <div className='bsq-radio'>
        <input
          type="radio"
          className=""
          name="sel-type"
          id="opc-trans"
          checked={selectedOption === 'opc-trans'}
          onChange={() => handleOptionChange('opc-trans')}
        />
        <label className="opc-busqueda" htmlFor="opc-trans">{t('cart.config.domain.transfer.label')}</label>
        <div className={`contenido-busqueda ${selectedOption !== 'opc-trans' ? 'bsq-hidden' : ''}`}>
          <div className='bsq-buscador'>
            <div className="input-container">
              <img src={icon} alt="Icon Busqueda" className="bsq-search-icon" />
              <input
                type="text"
                id="bsq-input-dominio"
                className={`form-control bsq-dominio-input ${inputError ? 'input-error' : ''}`}
                value={dominioTransferencia}
                placeholder={t('cart.config.domain.transfer.placeholder')}
                onChange={(e) => {
                  setDominioTransferencia(e.target.value);
                  setInputError(false);
                }}
                onFocus={() => setIcon(bsqicon2)} 
                onBlur={() => setIcon(bsqicon)} 
                onKeyDown={(e) => (e.key == 'Enter' && !loading) && handleTransferir()}
              />
            </div>
            <button className="bsq-btn-buscar" onClick={handleTransferir}>{t('cart.config.domain.transfer.btn')}</button>
          </div>
          <div>
            {loading &&
              <div className='bsq-load'>
                <img src={loadingIcon} alt="Cargando..." className="bsq-load-icon" />
              </div>
            }
            {message && msgresult == 'green' &&
              <p className={`transfer-msg ${msgresult}`}>{message}<br/><br/>
                <span className="transfer-msg-succes" 
                dangerouslySetInnerHTML={{ __html: t('cart.config.domain.transfer.success_message') }} 
                ></span>
              </p>
            }
            {message && msgresult == 'red' &&
              <p className={`transfer-msg ${msgresult}`}>{message}</p>
            }
          </div>
        </div>
      </div>
    </div>
      
     
  );
}

export default Transferencia;
